import { render, staticRenderFns } from "./YearCrud.vue?vue&type=template&id=bfb05a5c&scoped=true&"
import script from "./YearCrud.vue?vue&type=script&lang=js&"
export * from "./YearCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb05a5c",
  null
  
)

export default component.exports